import styled from 'styled-components';
import { BasketPriceDetailsStyled } from '../BasketPriceDetailsStyled';
import { rem } from 'polished';

export const BasketPriceDetailsAC = styled(BasketPriceDetailsStyled)`
    .titleWrapper {
        .title {
            font-size: ${({ theme }) => theme.fontSizes.h2};
        }

        .isClose,
        .isOpen {
            svg {
                width: ${rem('19px')} !important;
                height: ${rem('11px')} !important;
            }
        }

        .isClose {
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.red};
                }
            }
        }
        .isOpen {
            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.red};
                }
            }
        }
    }
`;
